// Curated Kerala imagery for SouthTrip.in (frontend-only seed data)

export const HERO_IMAGES = [
    "https://images.unsplash.com/photo-1766404891650-492a7192696b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxrZXJhbGElMjBiYWNrd2F0ZXJzJTIwaG91c2Vib2F0JTIwc3Vuc2V0fGVufDB8fHx8MTc3NzEzODM3Nnww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1742106854508-3b9172e52545?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxtdW5uYXIlMjB0ZWElMjBnYXJkZW5zJTIwbGFuZHNjYXBlfGVufDB8fHx8MTc3NzEzODM3Nnww&ixlib=rb-4.1.0&q=85",
];

const IMG_MUNNAR =
    "https://images.unsplash.com/photo-1774671791190-e1d226ba2c00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxtdW5uYXIlMjB0ZWElMjBnYXJkZW5zJTIwbGFuZHNjYXBlfGVufDB8fHx8MTc3NzEzODM3Nnww&ixlib=rb-4.1.0&q=85";
const IMG_ALLEPPEY =
    "https://images.unsplash.com/photo-1768661654336-d52da9a5c089?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxhbGxlcHBleSUyMGJhY2t3YXRlcnMlMjBib2F0fGVufDB8fHx8MTc3NzEzODM5MHww&ixlib=rb-4.1.0&q=85";
const IMG_WAYANAD =
    "https://images.unsplash.com/photo-1669830041409-9bed964b5aad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHx3YXlhbmFkJTIwZm9yZXN0JTIwbW91bnRhaW5zfGVufDB8fHx8MTc3NzEzODM5MHww&ixlib=rb-4.1.0&q=85";
const IMG_TRIVANDRUM =
    "https://images.pexels.com/photos/10329534/pexels-photo-10329534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_CALICUT =
    "https://images.unsplash.com/photo-1649075545398-68c780ef7b34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxjYWxpY3V0JTIwYmVhY2glMjBpbmRpYXxlbnwwfHx8fDE3NzcxMzgzNzZ8MA&ixlib=rb-4.1.0&q=85";
const IMG_KATHAKALI =
    "https://images.unsplash.com/photo-1741243779078-5b54c0013534?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxrZXJhbGElMjB0ZW1wbGUlMjB0cmFkaXRpb25hbCUyMGthdGhha2FsaXxlbnwwfHx8fDE3NzcxMzgzNzZ8MA&ixlib=rb-4.1.0&q=85";

export const DESTINATIONS = [
    {
        name: "Munnar",
        tagline: "Tea-clad highlands",
        image: IMG_MUNNAR,
        blurb: "Sprawling tea estates, misty peaks and waterfalls.",
    },
    {
        name: "Alleppey",
        tagline: "Backwaters & houseboats",
        image: IMG_ALLEPPEY,
        blurb: "Cruise the Venice of the East on traditional kettuvallams.",
    },
    {
        name: "Thekkady",
        tagline: "Wildlife in the wild",
        image: "https://images.unsplash.com/photo-1601225998165-a4b9d09ea58a?auto=format&fit=crop&w=1200&q=80",
        blurb: "Periyar Tiger Reserve, spice plantations and bamboo rafting.",
    },
    {
        name: "Vagamon",
        tagline: "Meadows of the meadows",
        image: "https://images.unsplash.com/photo-1469125155630-7ed37e065743?auto=format&fit=crop&w=1200&q=80",
        blurb: "Rolling green meadows, pine forests and paragliding.",
    },
    {
        name: "Wayanad",
        tagline: "Jungle escapes",
        image: IMG_WAYANAD,
        blurb: "Caves, waterfalls and Western Ghats wilderness.",
    },
    {
        name: "Kovalam",
        tagline: "Crescent-shaped beaches",
        image: "https://images.unsplash.com/photo-1582535866687-4a76683ad399?auto=format&fit=crop&w=1200&q=80",
        blurb: "Iconic lighthouse beach with Arabian sea sunsets.",
    },
    {
        name: "Trivandrum",
        tagline: "Capital of culture",
        image: IMG_TRIVANDRUM,
        blurb: "Temples, museums and Padmanabhaswamy heritage.",
    },
    {
        name: "Cochin",
        tagline: "Old-world harbour town",
        image: IMG_KATHAKALI,
        blurb: "Chinese fishing nets, Fort Kochi cafés and Jew Town.",
    },
    {
        name: "Calicut",
        tagline: "Spice-port history",
        image: IMG_CALICUT,
        blurb: "Where Vasco da Gama landed — beaches & banana chips.",
    },
    {
        name: "Kannur",
        tagline: "Theyyam coastline",
        image: "https://images.unsplash.com/photo-1558981403-c5f9899a28bc?auto=format&fit=crop&w=1200&q=80",
        blurb: "Untouched beaches, forts and ritual Theyyam art.",
    },
];

export const KERALA_CITIES = [
    "Cochin",
    "Trivandrum",
    "Calicut",
    "Munnar",
    "Alleppey",
    "Thekkady",
    "Vagamon",
    "Wayanad",
    "Kovalam",
    "Kannur",
    "Kumarakom",
    "Kanyakumari",
    "Ernakulam",
    "Kottayam",
    "Palakkad",
    "Thrissur",
    "Kollam",
];

const IMG_SEDAN =
    "https://images.unsplash.com/photo-1714502524998-e8ea4dd3781d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHx3aGl0ZSUyMHNlZGFuJTIwdGF4aSUyMGNhYiUyMGluZGlhfGVufDB8fHx8MTc3NzEzODM5MHww&ixlib=rb-4.1.0&q=85";
const IMG_SUV =
    "https://images.pexels.com/photos/6726680/pexels-photo-6726680.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_TEMPO =
    "https://images.unsplash.com/photo-1570125909232-eb263c188f7e?auto=format&fit=crop&w=1200&q=80";
const IMG_BUS =
    "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=1200&q=80";

export const SEED_CABS = [
    {
        id: "cab-1",
        name: "Swift Dzire",
        category: "Sedan",
        seats: 4,
        ratePerDay: 1900,
        kmLimit: 100,
        image: IMG_SEDAN,
        description:
            "Comfortable, fuel-efficient sedan ideal for couples and small families.",
        features: ["AC", "Music System", "Driver", "100 KM/day"],
        active: true,
    },
    {
        id: "cab-2",
        name: "Toyota Etios",
        category: "Sedan",
        seats: 4,
        ratePerDay: 1900,
        kmLimit: 100,
        image: IMG_SEDAN,
        description:
            "Reliable Toyota sedan with spacious boot — great for airport transfers.",
        features: ["AC", "Music System", "Driver", "100 KM/day"],
        active: true,
    },
    {
        id: "cab-3",
        name: "Honda Amaze",
        category: "Sedan",
        seats: 4,
        ratePerDay: 1900,
        kmLimit: 100,
        image: IMG_SEDAN,
        description: "Refined ride quality with premium interiors.",
        features: ["AC", "Music System", "Driver", "100 KM/day"],
        active: true,
    },
    {
        id: "cab-4",
        name: "Honda CRV",
        category: "SUV",
        seats: 6,
        ratePerDay: 2200,
        kmLimit: 100,
        image: IMG_SUV,
        description: "Premium SUV with excellent road presence.",
        features: ["AC", "Music System", "Driver", "Luggage space"],
        active: true,
    },
    {
        id: "cab-5",
        name: "Suzuki Ertiga",
        category: "MPV",
        seats: 5,
        ratePerDay: 2100,
        kmLimit: 100,
        image: IMG_SUV,
        description: "Comfortable MPV great for families with kids.",
        features: ["AC", "Music System", "Driver", "Spacious"],
        active: true,
    },
    {
        id: "cab-6",
        name: "Toyota Innova",
        category: "MPV",
        seats: 7,
        ratePerDay: 2400,
        kmLimit: 100,
        image: IMG_SUV,
        description:
            "India's favourite tourist MPV — proven reliability for long Kerala trips.",
        features: ["AC", "Music System", "Driver", "Bigger boot"],
        active: true,
    },
    {
        id: "cab-7",
        name: "Innova Crysta",
        category: "Premium MPV",
        seats: 6,
        ratePerDay: 2800,
        kmLimit: 100,
        image: IMG_SUV,
        description: "Premium captain seats and superior ride comfort.",
        features: ["AC", "Captain Seats", "Driver", "Luxury feel"],
        active: true,
    },
    {
        id: "cab-8",
        name: "Force Urbania",
        category: "Luxury Van",
        seats: 14,
        ratePerDay: 7500,
        kmLimit: 100,
        image: IMG_TEMPO,
        description:
            "Top-end luxury van for groups — push-back seats and panoramic windows.",
        features: ["Pushback Seats", "AC", "Driver", "USB charging"],
        active: true,
    },
    {
        id: "cab-9",
        name: "Tempo 10-12 Seat",
        category: "Tempo Traveller",
        seats: 12,
        ratePerDay: 3300,
        kmLimit: 100,
        image: IMG_TEMPO,
        description: "Standard tempo traveller for medium groups.",
        features: ["AC", "Driver", "Luggage space"],
        active: true,
    },
    {
        id: "cab-10",
        name: "Tempo 17 Seat",
        category: "Tempo Traveller",
        seats: 17,
        ratePerDay: 4000,
        kmLimit: 100,
        image: IMG_TEMPO,
        description: "Roomy tempo for large families and friend groups.",
        features: ["AC", "Driver", "High roof"],
        active: true,
    },
    {
        id: "cab-11",
        name: "Tempo 20 Seat",
        category: "Mini Bus",
        seats: 20,
        ratePerDay: 5300,
        kmLimit: 100,
        image: IMG_BUS,
        description: "Comfortable mini-bus for corporate and family groups.",
        features: ["AC", "Driver", "Push-back seats"],
        active: true,
    },
    {
        id: "cab-12",
        name: "Tempo 26 Seat",
        category: "Mini Bus",
        seats: 26,
        ratePerDay: 5300,
        kmLimit: 100,
        image: IMG_BUS,
        description: "Largest mini-bus for big tour groups.",
        features: ["AC", "Driver", "Spacious cabin"],
        active: true,
    },
];

const buildItinerary = (route, days) => {
    const stops = route.split(/–|-/).map((s) => s.trim()).filter(Boolean);
    const result = [];
    for (let i = 0; i < days; i++) {
        const from = stops[Math.min(i, stops.length - 1)];
        const to = stops[Math.min(i + 1, stops.length - 1)];
        if (i === 0) {
            result.push({
                day: 1,
                title: `Arrival in ${from}`,
                details: `Pickup from ${from} airport/railway station. Drive to ${to}, check-in to your hotel and unwind. Evening at leisure to soak in local Kerala flavours.`,
            });
        } else if (i === days - 1) {
            result.push({
                day: i + 1,
                title: `Departure from ${stops[stops.length - 1]}`,
                details: `Post breakfast, drop-off at ${stops[stops.length - 1]} airport/railway station with sweet Kerala memories.`,
            });
        } else {
            result.push({
                day: i + 1,
                title: `${from} → ${to}`,
                details: `Morning sightseeing in ${from} — top viewpoints and local experiences. Drive scenic to ${to}; evening hotel check-in and stroll around the local area.`,
            });
        }
    }
    return result;
};

const PKG_INCLUSIONS = [
    "AC cab with experienced driver",
    "Fuel & toll charges",
    "Driver bata & parking fees",
    "Pickup & drop at start city",
    "All transfers as per itinerary",
];
const PKG_EXCLUSIONS = [
    "Hotel accommodation",
    "Meals (breakfast/lunch/dinner)",
    "Monument & entry fees",
    "Personal expenses & tips",
    "Anything not mentioned in inclusions",
];

const mkPkg = (id, startCity, route, days, km, price, image, highlight) => ({
    id,
    name: `${days} Days ${days - 1} Nights ${route}`,
    startingCity: startCity,
    route,
    days,
    nights: days - 1,
    km,
    price,
    image,
    highlight,
    inclusions: PKG_INCLUSIONS,
    exclusions: PKG_EXCLUSIONS,
    itinerary: buildItinerary(route, days),
    active: true,
});

export const SEED_PACKAGES = [
    // Cochin commencing
    mkPkg("pkg-c-1", "Cochin", "Cochin – Munnar – Cochin", 3, 350, 8300, IMG_MUNNAR, "Misty hills escape"),
    mkPkg("pkg-c-2", "Cochin", "Cochin – Vagamon – Cochin", 3, 350, 8300, "https://images.unsplash.com/photo-1469125155630-7ed37e065743?auto=format&fit=crop&w=1200&q=80", "Meadow weekend"),
    mkPkg("pkg-c-3", "Cochin", "Cochin – Kumarakom – Alleppey – Cochin", 3, 300, 7900, IMG_ALLEPPEY, "Backwater bliss"),
    mkPkg("pkg-c-4", "Cochin", "Cochin – Munnar – Alleppey – Cochin", 4, 500, 12350, IMG_MUNNAR, "Hills + houseboat combo"),
    mkPkg("pkg-c-5", "Cochin", "Cochin – Munnar – Thekkady – Cochin", 4, 600, 13800, "https://images.unsplash.com/photo-1601225998165-a4b9d09ea58a?auto=format&fit=crop&w=1200&q=80", "Wildlife & tea"),
    mkPkg("pkg-c-6", "Cochin", "Cochin – Thekkady – Alleppey – Cochin", 4, 550, 12900, IMG_ALLEPPEY, "Spices & backwaters"),
    mkPkg("pkg-c-7", "Cochin", "Cochin – Vagamon – Alleppey – Cochin", 4, 450, 11200, IMG_ALLEPPEY, "Meadows to backwaters"),
    mkPkg("pkg-c-8", "Cochin", "Cochin – Munnar – Vagamon – Alleppey – Cochin", 5, 650, 14300, IMG_MUNNAR, "Best of central Kerala"),
    mkPkg("pkg-c-9", "Cochin", "Cochin – Munnar – Thekkady – Alleppey – Cochin", 5, 650, 14300, IMG_MUNNAR, "Classic Kerala"),
    mkPkg("pkg-c-10", "Cochin", "Cochin – Munnar – Thekkady – Alleppey – Cochin", 6, 700, 15950, IMG_ALLEPPEY, "Extended classic"),
    mkPkg("pkg-c-11", "Cochin", "Cochin – Munnar – Alleppey – Kovalam – Trivandrum", 6, 950, 20700, "https://images.unsplash.com/photo-1582535866687-4a76683ad399?auto=format&fit=crop&w=1200&q=80", "Hills to coast"),
    mkPkg("pkg-c-12", "Cochin", "Cochin – Munnar – Thekkady – Alleppey – Kovalam – Trivandrum", 7, 1000, 22700, "https://images.unsplash.com/photo-1582535866687-4a76683ad399?auto=format&fit=crop&w=1200&q=80", "Grand Kerala tour"),
    mkPkg("pkg-c-13", "Cochin", "Cochin – Munnar – Thekkady – Alleppey – Kovalam – Kanyakumari – Trivandrum", 8, 1200, 27250, IMG_KATHAKALI, "South India circuit"),
    mkPkg("pkg-c-14", "Cochin", "Cochin – Munnar – Thekkady – Alleppey – Kovalam – Kanyakumari – Trivandrum", 9, 1300, 29350, IMG_KATHAKALI, "Extended south circuit"),
    mkPkg("pkg-c-15", "Cochin", "Cochin – Munnar – Thekkady – Alleppey – Kovalam – Kanyakumari – Trivandrum", 10, 1300, 30000, IMG_KATHAKALI, "The Grand Kerala"),
    // Trivandrum commencing
    mkPkg("pkg-t-1", "Trivandrum", "Trivandrum – Kovalam – Alleppey – Munnar – Cochin", 6, 950, 20700, "https://images.unsplash.com/photo-1582535866687-4a76683ad399?auto=format&fit=crop&w=1200&q=80", "Coast to hills"),
    mkPkg("pkg-t-2", "Trivandrum", "Trivandrum – Kovalam – Alleppey – Thekkady – Munnar – Cochin", 7, 1000, 22700, IMG_MUNNAR, "South-to-north Kerala"),
    mkPkg("pkg-t-3", "Trivandrum", "Trivandrum – Kanyakumari – Kovalam – Alleppey – Thekkady – Munnar – Cochin", 8, 1200, 27250, IMG_TRIVANDRUM, "Kanyakumari + Kerala"),
    mkPkg("pkg-t-4", "Trivandrum", "Trivandrum – Kanyakumari – Kovalam – Alleppey – Thekkady – Munnar – Cochin", 9, 1300, 29350, IMG_TRIVANDRUM, "Extended south combo"),
    mkPkg("pkg-t-5", "Trivandrum", "Trivandrum – Kanyakumari – Kovalam – Alleppey – Thekkady – Munnar – Cochin", 10, 1300, 30000, IMG_TRIVANDRUM, "Ultimate south India"),
    // Calicut commencing
    mkPkg("pkg-k-1", "Calicut", "Calicut – Wayanad – Calicut", 3, 450, 10000, IMG_WAYANAD, "Wayanad weekend"),
    mkPkg("pkg-k-2", "Calicut", "Calicut – Wayanad – Calicut", 4, 550, 12500, IMG_WAYANAD, "Extended Wayanad"),
    mkPkg("pkg-k-3", "Calicut", "Calicut – Wayanad – Calicut", 5, 600, 15000, IMG_WAYANAD, "Deep Wayanad escape"),
    mkPkg("pkg-k-4", "Calicut", "Calicut – Wayanad – Kannur", 4, 550, 14000, "https://images.unsplash.com/photo-1558981403-c5f9899a28bc?auto=format&fit=crop&w=1200&q=80", "Wayanad + coast"),
    mkPkg("pkg-k-5", "Calicut", "Calicut – Wayanad – Kannur", 5, 650, 18000, "https://images.unsplash.com/photo-1558981403-c5f9899a28bc?auto=format&fit=crop&w=1200&q=80", "Wayanad + Kannur extended"),
];

export const TESTIMONIALS = [
    {
        name: "Aarav Mehta",
        city: "Mumbai",
        rating: 5,
        text: "The Innova Crysta we booked through SouthTrip was spotless and the driver, Suresh, was a Kerala encyclopedia. Made our Munnar trip unforgettable.",
        avatar: "https://images.unsplash.com/photo-1728053914354-e1e3e09f6239?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBzbWlsaW5nJTIwcG9ydHJhaXQlMjBhdmF0YXJ8ZW58MHx8fHwxNzc3MTM4Mzc2fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        name: "Priya Sundar",
        city: "Bangalore",
        rating: 5,
        text: "Booked the 6 day Cochin–Munnar–Thekkady–Alleppey package. Pricing was honest, no hidden costs and houseboat day was magical.",
        avatar: "https://images.pexels.com/photos/36342206/pexels-photo-36342206.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        name: "Rohan Iyer",
        city: "Chennai",
        rating: 5,
        text: "Tempo Traveller for our 14-member family — clean, on-time and the route was customised for elders. SouthTrip is now our go-to for Kerala.",
        avatar: "https://images.unsplash.com/photo-1674278882093-3870ef98e826?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBzbWlsaW5nJTIwcG9ydHJhaXQlMjBhdmF0YXJ8ZW58MHx8fHwxNzc3MTM4Mzc2fDA&ixlib=rb-4.1.0&q=85",
    },
];

export const DEFAULT_SETTINGS = {
    phone: "+91 80-75814740",
    email: "info@southtrip.in",
    whatsapp: "+918075814740",
    address:
        "35 P/N, Kavarapparambu Road, Angamaly, Priya Nagar Road, Nedumbassery, Near Priya Arts and Sports Club, Ernakulam – 683572, Kerala, India",
    bookingsEnabled: true,
    promoText: "Limited-time: Free pickup within 25 km on all packages.",
    bannerMessage: "Explore Kerala, Comfortably",
};

export const ADMIN_CREDENTIALS = {
    username: "admin",
    password: "southtrip@123",
};
